import { fmtCRC } from '../api';
import { IconCash } from './Icons';

// Ventanas de "por vencer" que ofrece la interfaz (iguales a las del servidor)
export const DUE_WINDOWS = [3, 7, 15, 30];

// Estado inicial del filtro de vencimientos
export const emptyDue = { preset: '', days: 7, from: '', to: '' };

// Traduce el filtro a los parámetros que entiende /api/subscriptions
export const dueParams = ({ preset, days, from, to } = emptyDue) => {
  const params = new URLSearchParams();
  if (preset) params.set('due', preset);
  if (preset === 'por_vencer' || preset === 'atencion') params.set('days', String(days));
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  return params;
};

export const hasDueFilter = (due) => Boolean(due.preset || due.from || due.to);

// Barra de filtros por fecha de vencimiento: atajos (vencidas, vence hoy, por
// vencer, sin fecha) más un rango personalizado. `summary` viene de
// /api/subscriptions/summary y sirve para mostrar cuántas hay en cada grupo.
export default function DueFilter({ value, onChange, summary }) {
  const set = (patch) => onChange({ ...value, ...patch });
  const pick = (preset) => set({ preset: value.preset === preset ? '' : preset });

  const chips = [
    { key: '', label: 'Todas', count: summary?.total, tone: 'is-neutral' },
    { key: 'vencidas', label: 'Vencidas', count: summary?.vencidas, tone: 'is-danger' },
    { key: 'hoy', label: 'Vence hoy', count: summary?.hoy, tone: 'is-amber' },
    { key: 'por_vencer', label: `Por vencer (${value.days} días)`, count: summary?.porVencer?.[value.days], tone: 'is-amber' },
    { key: 'sin_fecha', label: 'Sin fecha', count: summary?.sinFecha, tone: 'is-neutral' },
  ];

  return (
    <div className="due-filter">
      <div className="due-filter-row">
        {chips.map((c) => (
          <button
            key={c.key || 'todas'}
            type="button"
            onClick={() => (c.key ? pick(c.key) : onChange({ ...value, preset: '', from: '', to: '' }))}
            className={`due-chip ${c.tone} ${(c.key ? value.preset === c.key : !hasDueFilter(value)) ? 'is-active' : ''}`}
          >
            {c.label}
            {c.count != null && <span className="due-chip-count">{c.count}</span>}
          </button>
        ))}

        {value.preset === 'por_vencer' && (
          <select className="input inline-block w-auto" value={value.days} onChange={(e) => set({ days: Number(e.target.value) })}>
            {DUE_WINDOWS.map((d) => <option key={d} value={d}>{d} días</option>)}
          </select>
        )}
      </div>

      <div className="due-filter-row">
        <label className="due-range">
          <span>Vence desde</span>
          <input className="input" type="date" value={value.from} max={value.to || undefined} onChange={(e) => set({ from: e.target.value })} />
        </label>
        <label className="due-range">
          <span>hasta</span>
          <input className="input" type="date" value={value.to} min={value.from || undefined} onChange={(e) => set({ to: e.target.value })} />
        </label>
        {hasDueFilter(value) && (
          <button type="button" className="due-clear" onClick={() => onChange({ ...emptyDue })}>Limpiar filtros</button>
        )}
      </div>

      {summary && (summary.montoVencido > 0 || summary.montoPorVencer > 0) && (
        <div className="due-summary">
          <span className="due-summary-icon"><IconCash size={16} /></span>
          <span>
            <b className="text-red-400">{fmtCRC(summary.montoVencido)}</b> vencidos sin cobrar
            {' · '}
            <b className="text-amber-400">{fmtCRC(summary.montoPorVencer)}</b> por cobrar en {summary.days} días
          </span>
        </div>
      )}
    </div>
  );
}
